export class Product {
    userInfoId: any; 
    sellProductInfoId: number | undefined; 
    sellProductTitle: string | undefined;
    sellProductPrice: number | undefined; 
    sellProductDiscount: number | undefined; 
    sellProductQty: Number | undefined; 
    sellProductDetails: string | undefined; 
    sellProductImageURL: string | undefined;
    sellProductAdditionalInfo: String | undefined; 
    sellProductStartDate: any | undefined; 
    sellProductEndDate: any | undefined;
    sellProductCategory: number | undefined;
    sellProductSubCategory:number | undefined;
    sellProductCountry: any | undefined;
    sellProductState:any | undefined;
    sellProductDistrict: any | undefined;
    status?:boolean; 
}
